/**
 * Validated public configuration.
 *
 * Only non-secret values belong here — everything in `import.meta.env` is compiled
 * into the bundle and is readable by anyone who opens devtools.
 */

function readString(value: unknown, fallback: string): string {
  return typeof value === 'string' && value.length > 0 ? value : fallback
}

function readNumber(value: unknown, fallback: number): number {
  const parsed = Number(value)
  return Number.isFinite(parsed) && parsed > 0 ? parsed : fallback
}

export const env = {
  /**
   * Empty in development so requests go to the same origin and Vite proxies them.
   * Set to the API origin in production.
   */
  apiBaseUrl: readString(import.meta.env.VITE_API_BASE_URL, '').replace(/\/$/, ''),
  appName: readString(import.meta.env.VITE_APP_NAME, 'True Flat Admin'),
  requestTimeoutMs: readNumber(import.meta.env.VITE_REQUEST_TIMEOUT_MS, 30_000),
  isProduction: import.meta.env.PROD,
  isDevelopment: import.meta.env.DEV,
} as const

/** Backend route prefixes. Never build these by hand at a call site. */
export const API = {
  v1: '/api/v1',
  admin: '/admin/v1',
} as const
